import React from 'react';
import { ExternalLink } from '../../components';

const SpanishCookiePolicy = () => {
    return (
        <>
            <p className="lastUpdated">Última actualización: 14 de enero de 2025</p>
            <h2>1. Introducción</h2>
            <p>
                Bienvenido a regenera.earth. Nos comprometemos a proteger su información personal y
                respetar su privacidad. Esta Política de Cookies explica cómo usamos cookies y
                tecnologías similares en nuestro sitio web.
            </p>
            <h2>2. Entendiendo las Cookies</h2>
            <p>
                Las cookies son pequeños archivos de datos enviados desde el servidor de un sitio
                web a su navegador web y almacenados en su dispositivo. Cada vez que visita una
                página en nuestro sitio, su navegador envía estos datos de vuelta a nuestro
                servidor. Este proceso nos ayuda a reconocer su navegador y a rastrear su actividad
                en nuestro sitio web.
            </p>
            <h4>Tipos de Cookies que Usamos</h4>
            <ul>
                <li>
                    Cookies de Sesión: Estas cookies son temporales y se eliminan cuando cierra su
                    navegador. Nos permiten rastrear sus acciones durante una única sesión de
                    navegación, facilitando una navegación más fluida en nuestro sitio.
                </li>
                <li>
                    Cookies Persistentes: Estas permanecen en su dispositivo incluso después de
                    cerrar su navegador. Las cookies persistentes ayudan a nuestro sitio web a
                    recordar sus preferencias y a reconocerlo en visitas posteriores, para que no
                    tenga que ingresar la misma información cada vez.
                </li>
            </ul>
            <h2>3. Gestión de Cookies</h2>
            <p>
                Las cookies de sesión se eliminan al salir de su navegador, mientras que las cookies
                persistentes permanecen en su dispositivo hasta que las elimine manualmente o hasta
                que expiren después de un período establecido.
            </p>
            <p>
                La mayoría de los navegadores web le permiten controlar las cookies a través de las
                configuraciones, o puede optar por aceptar o rechazar (todas) las cookies
                directamente en nuestro sitio web cuando aparezca el aviso de cookies. Sin embargo,
                tenga en cuenta que desactivar las cookies puede afectar la funcionalidad de nuestro
                sitio web.
            </p>
            <h2>4. Cómo Usamos las Cookies</h2>
            <p>Usamos cookies para: </p>
            <ul>
                <li>
                    Garantizar la Funcionalidad del Sitio Web: Activar funcionalidades esenciales
                    como seguridad, gestión de red y accesibilidad.
                </li>
                <li>
                    Mejorar la Experiencia del Usuario: Recordar sus preferencias y personalizar el
                    contenido.
                </li>
                <li>
                    Analizar el Rendimiento: Entender cómo los visitantes interactúan con nuestro
                    sitio web para mejorar la funcionalidad y la experiencia del usuario.
                </li>
            </ul>
            <h2>5. Cookies que Usamos</h2>
            <ul>
                <li>
                    Cookies Esenciales: Necesarias para el funcionamiento de nuestro sitio web.
                    Incluyen, por ejemplo, cookies que le permiten iniciar sesión en áreas seguras.
                </li>
                <li>
                    Cookies Analíticas/De Rendimiento: Nos permiten reconocer y contar el número de
                    visitantes y ver cómo se mueven por nuestro sitio web.
                </li>
                <li>
                    Cookies de Funcionalidad: Se utilizan para reconocerlo cuando regresa a nuestro
                    sitio web y personalizar el contenido para usted.
                </li>
                <li>
                    Cookies de Orientación: Registran su visita a nuestro sitio web, las páginas
                    visitadas y los enlaces seguidos para hacer que nuestro sitio sea más relevante
                    para sus intereses.
                </li>
                <li>
                    Cookies de Redes Sociales: Nuestro sitio web incluye funciones de redes
                    sociales, como el botón "Me gusta" de Facebook, el botón "Tweet" de Twitter y el
                    botón "Compartir" de LinkedIn. Estas funciones pueden recopilar su dirección IP,
                    la página que está visitando en nuestro sitio, y pueden establecer una cookie
                    para que la función funcione correctamente.
                </li>
            </ul>
            <h2>6. Cookies de Terceros</h2>
            <p>
                Podemos usar servicios de terceros como Google Analytics con fines analíticos. Estos
                terceros pueden establecer sus propias cookies en su dispositivo. No controlamos el
                uso de estas cookies y le recomendamos que consulte los sitios web de terceros para
                obtener más información sobre sus cookies y cómo gestionarlas.
            </p>
            <p>Otras Cookies de Terceros</p>
            <ul>
                <li>
                    Facebook: Usamos complementos de Facebook para permitirle compartir contenido.
                    Facebook puede establecer cookies en su dispositivo y recopilar datos según su
                    Política de Datos.
                </li>
                <li>
                    Twitter: Los widgets de Twitter permiten compartir contenido y pueden colocar
                    cookies en su dispositivo. Para más información, consulte la Política de
                    Privacidad de Twitter.
                </li>
                <li>
                    LinkedIn: Los botones de compartir de LinkedIn pueden recopilar datos y
                    establecer cookies. Por favor, revise la Política de Privacidad de LinkedIn para
                    más detalles.
                </li>
            </ul>
            <p>Sus Opciones</p>
            <p>
                Puede gestionar o desactivar las cookies de redes sociales a través de la
                configuración de su navegador o ajustando sus preferencias en las plataformas de
                redes sociales respectivas. Tenga en cuenta que desactivar estas cookies puede
                afectar la funcionalidad de las funciones de compartir en nuestro sitio web.
            </p>
            <h2>7. Cambios en Esta Política de Cookies</h2>
            <p>
                Podemos actualizar esta Política de Cookies de vez en cuando. Los cambios serán
                efectivos cuando publiquemos la política revisada en nuestro sitio web. Por favor,
                consulte esta página periódicamente para actualizaciones.
            </p>
            <h2>8. Contáctenos</h2>
            <p>
                Si tiene preguntas o inquietudes sobre nuestro uso de cookies, contáctenos en:{' '}
                <ExternalLink
                    href="mailto:community@regenera.earth"
                    className="green-link flex items-center"
                >
                    {process.env.REACT_APP_REPLY_TO_EMAIL_ADDRESS}
                </ExternalLink>{' '}
            </p>

            <h2>9. Consentimiento</h2>
            <p>
                Al continuar usando nuestro sitio web sin cambiar su configuración o rechazar
                nuestras cookies, usted acepta el uso de cookies según lo descrito en esta política.
            </p>
        </>
    );
};

export default SpanishCookiePolicy;
